import { Button } from '@toggle/design-system';
import React, { ReactNode } from 'react';

import styles from './NoDataFound.module.scss';

export interface NoDataFoundProps {
  bannerPath: string;
  title?: string;
  description?: string;
  buttonLabel?: string;
  buttonAction?: () => void;
  children?: ReactNode;
}

export const NoDataFound = ({
  bannerPath,
  title,
  description,
  buttonLabel,
  buttonAction,
  children,
  ...rest
}: NoDataFoundProps) => {
  return (
    <div className={styles.emptyPortfolioWrapper} {...rest}>
      <img className={styles.styledImg} src={bannerPath} />
      <span className={styles.title}>{title}</span>
      <span className={styles.description}>{description}</span>
      {buttonAction && (
        <Button
          className={styles.addAssetsButton}
          onClick={buttonAction}
          label={buttonLabel}
        />
      )}
      {children}
    </div>
  );
};
